module.exports = __webpack_public_path__ + "img/img4.af1857aa.png";